import styled from 'styled-components'

export const CityPlanCreateWrapper = styled.div``



// WEBPACK FOOTER //
// ./src/Components/Campaigns/CityPlanCreate/CityPlanCreateWrapper/index.js